import React from 'react';
import { Button } from './ui/Button';
import { PhoneIcon, MessageCircleIcon, MailIcon, ClockIcon } from 'lucide-react';
export function ContactCTA() {
  return <section id="contacto" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-primary-600 to-primary-700" data-id="element-42">
      <div className="max-w-4xl mx-auto text-center" data-id="element-43">
        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-44">
          ¿Listo para optimizar tu operación?
        </h2>
        <p className="text-xl text-primary-100 mb-8" data-id="element-45">
          Obtén una cotización personalizada en menos de 30 segundos
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12" data-id="element-46">
          <Button size="lg" variant="secondary" data-id="element-47">
            Cotiza Ahora
          </Button>
          <Button size="lg" variant="outline" className="!text-white !border-white hover:!bg-white/10" data-id="element-48">
            <MessageCircleIcon className="w-5 h-5" data-id="element-49" />
            WhatsApp
          </Button>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-3xl mx-auto" data-id="element-50">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-white" data-id="element-51">
            <PhoneIcon className="w-8 h-8 mx-auto mb-3 text-primary-100" data-id="element-52" />
            <h3 className="font-semibold mb-1" data-id="element-53">Llámanos</h3>
            <p className="text-sm text-primary-100" data-id="element-54">55 1234 5678</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-white" data-id="element-55">
            <MailIcon className="w-8 h-8 mx-auto mb-3 text-primary-100" data-id="element-56" />
            <h3 className="font-semibold mb-1" data-id="element-57">Escríbenos</h3>
            <p className="text-sm text-primary-100" data-id="element-58">contacto@arrendalogic.mx</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-white" data-id="element-59">
            <ClockIcon className="w-8 h-8 mx-auto mb-3 text-primary-100" data-id="element-60" />
            <h3 className="font-semibold mb-1" data-id="element-61">Horario</h3>
            <p className="text-sm text-primary-100" data-id="element-62">Lun - Vie: 9am - 6pm</p>
          </div>
        </div>

        <p className="text-primary-100 text-sm mt-8" data-id="element-63">
          Te respondemos en menos de 5 minutos durante horario laboral
        </p>
      </div>
    </section>;
}